const steps =
    [
       {
          _id: 1,
          content: {
             "blocks": [
                {
                   "key": "7pg0e",
                   "text": "Navigate to. https://www.figma.com..",
                   "type": "unstyled",
                   "depth": 0,
                   "inlineStyleRanges": [],
                   "entityRanges": [],
                   "data": {}
                }
             ],
             "entityMap": {}
          }
       },
       {
          _id: 2,
          content: {
             "blocks": [
                {
                   "key": "7pg0e",
                   "text": "Open the Prototype tab in the right sidebar",
                   "type": "unstyled",
                   "depth": 0,
                   "inlineStyleRanges": [],
                   "entityRanges": [],
                   "data": {}
                }
             ],
             "entityMap": {}
          },
          image: 'screen-1.png'
       },
       {
          _id: 3,
          content: {
             "blocks": [
                {
                   "key": "7pg0e",
                   "text": "Add interactions and set interaction details",
                   "type": "unstyled",
                   "depth": 0,
                   "inlineStyleRanges": [],
                   "entityRanges": [],
                   "data": {}
                }
             ],
             "entityMap": {}
          },
          image: 'screen-2.png'
       },
       {
          _id: 4,
          content: {
             "blocks": [
                {
                   "key": "7pg0e",
                   "text": "Apply an animation",
                   "type": "unstyled",
                   "depth": 0,
                   "inlineStyleRanges": [],
                   "entityRanges": [],
                   "data": {}
                }
             ],
             "entityMap": {}
          }
       },
       {
          _id: 5,
          content: {
             "blocks": [
                {
                   "key": "7pg0e",
                   "text": "Preview your animation",
                   "type": "unstyled",
                   "depth": 0,
                   "inlineStyleRanges": [],
                   "entityRanges": [],
                   "data": {}
                }
             ],
             "entityMap": {}
          }
       },
       {
          _id: 6,
          content: {
             "blocks": [
                {
                   "key": "7pg0e",
                   "text": "Select a Device and Model",
                   "type": "unstyled",
                   "depth": 0,
                   "inlineStyleRanges": [],
                   "entityRanges": [],
                   "data": {}
                }
             ],
             "entityMap": {}
          }
       },
       {
          _id: 7,
          content: {
             "blocks": [
                {
                   "key": "7pg0e",
                   "text": "Preview your prototype",
                   "type": "unstyled",
                   "depth": 0,
                   "inlineStyleRanges": [],
                   "entityRanges": [],
                   "data": {}
                }
             ],
             "entityMap": {}
          }
       },
       {
          _id: 8,
          content: {
             "blocks": [
                {
                   "key": "7pg0e",
                   "text": "Select Background color",
                   "type": "unstyled",
                   "depth": 0,
                   "inlineStyleRanges": [],
                   "entityRanges": [],
                   "data": {}
                }
             ],
             "entityMap": {}
          }
       },
       {
          _id: 9,
          content: {
             "blocks": [
                {
                   "key": "7pg0e",
                   "text": "Set the prototype's Starting Frame",
                   "type": "unstyled",
                   "depth": 0,
                   "inlineStyleRanges": [],
                   "entityRanges": [],
                   "data": {}
                }
             ],
             "entityMap": {}
          }
       }
    ];


const filesAndFolders = [
   {
      name: 'Get started',
      _id: 1,
      files: [
         {
            name: 'Guide to prototyping',
            _id: 11
         },
         {
            name: 'Create interactions and animation',
            _id: 12
         },
         {
            name: 'Create connections',
            _id: 13
         }
      ]
   },
   {
      name: 'Images, shapes and tools',
      _id: 2,
      files: [
         {
            name: 'Flows and starting points',
            _id: 21
         }
      ]
   },
   {
      name: 'Create overlays in your prototypes',
      _id: 3,
      files: [
         {
            name: 'Create interactions and animation',
            _id: 31
         }
      ]
   },
   {
      name: 'Add video to prototypes',
      _id: 4,
      files: [
         {
            name: 'Guide to prototyping',
            _id: 41
         },
         {
            name: 'Create interactions and animation',
            _id: 42
         }
      ]
   },
]

export function getSteps() {
   return steps;
}

export function getFilesAndFolders() {
   return filesAndFolders;
}
